import axios from 'axios'
import { baseUrl } from '@/utils/baseData.js'
export const requestAll = (promiseArr) => axios.all(promiseArr)
class AxiosRequest {
  constructor () {
    // this.baseURL = process.env.NODE_ENV !== 'production' ? 'http://localhost:3000/api' : 'http:api.xxx.com'
    this.baseURL = baseUrl
    this.timeout = 5000
    this.queue = {}
  }

  setInterceptor (instance, options) {
    // console.log(instance, options)
    instance.interceptors.request.use((config) => {
      // 后面每一次请求时，得到一个取消请求方法
      const CancelToken = axios.CancelToken
      // 给config挂载了cancelToken的对象
      const key = config.url + '&' + config.method
      this.queue[key] && this.queue[key]('操作太频繁了~')
      config.cancelToken = new CancelToken((c) => {
        this.queue[key] = c
      })
      return config
    }, error => {
      return Promise.reject(error)
    })
    instance.interceptors.response.use((response) => {
      // 取消请求
      const key = response.config.url + '&' + response.config.method
      this.queue[key] && delete this.queue[key]
      return response.data
    }, error => {
      const key = options.url + '&' + options.method.toLowerCase()
      this.queue[key] && delete this.queue[key]
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    const config = {
      ...options,
      baseURL: this.baseURL,
      timeout: this.timeout
    }
    this.setInterceptor(instance, options)
    return instance(config)
  }
}
export default new AxiosRequest()
